/**
 * Composable for branding-related utilities
 * Provides methods to customize text with installation-specific branding
 */
import { useMapGetter } from 'dashboard/composables/store.js';

export function useBranding() {
  const globalConfig = useMapGetter('globalConfig/get');
  /**
   * Replaces "Chatwoot" in text with the installation name from global config
   * @param {string} text - The text to process
   * @returns {string} - Text with "Chatwoot" replaced by installation name
   */
  const replaceInstallationName = text => {
    if (!text) return text;

    const installationName = globalConfig.value?.installationName;
    if (!installationName) return text;

    return text.replace(/Chatwoot/g, installationName);
  };

  /**
   * Replaces brand name in email templates and other content
   * @param {string} text - The text to process
   * @returns {string} - Text with brand name replaced
   */
  const replaceBrandName = text => {
    if (!text) return text;

    const brandName = globalConfig.value?.brandName || globalConfig.value?.installationName;
    if (!brandName) return text;

    return text.replace(/Chatwoot/g, brandName);
  };

  return {
    replaceInstallationName,
    replaceBrandName,
  };
}
